import { type ReactNode } from "react";
import { useOnboarding, useDismissible } from "@safers/pwa";
import { usePushSubscription } from "@/hooks/usePushSubscription";
import { AppSetupContext } from "@/hooks/useAppSetup";

// 배너 내용이 바뀌면 키도 갈아야 한다 — 안 그러면 예전 배너를 닫아 둔 사용자가 새 안내를
// 남은 만료 기간(14일) 동안 못 본다. 설치 안내 → 알림 안내로 바뀌면서 갈았다.
const DISMISS_KEY = "safers-notification-dismissed";

/**
 * 설치·알림 안내 상태를 한 곳에서 들고 배너와 계정 메뉴가 나눠 쓴다.
 *
 * 컴포넌트마다 `useOnboarding` 을 따로 부르면 안 된다 — 권한이 허용된 상태에서는
 * 푸시 토큰 발급까지 시도하므로(`useOnboarding.ts` 의 pushProbe) 부른 만큼 프로브가 돈다.
 */
export function AppSetupProvider({ children }: { children: ReactNode }) {
  const { subscribe } = usePushSubscription(null);
  const { notification, install, env, installed } = useOnboarding({ pushProbe: subscribe });
  const { dismissed, dismiss, reset } = useDismissible(DISMISS_KEY);

  return (
    <AppSetupContext value={{ notification, install, env, installed, dismissed, dismiss, reset }}>
      {children}
    </AppSetupContext>
  );
}
